import { request } from 'umi';
import type { ApptItemShareQrCodeParams, IApptItemPageSearchParams } from './data';

// 分页查询预约项目列表[管理后台]
export async function getApptItemPageSearch(params: IApptItemPageSearchParams) {
  return request('/hm/mall/appt/item/pageSearch', {
    params
  });
}

// /mall/appt/item/updateShelfStatus 更新上架状态[管理后台]
export async function changeUpdateShelfStatus(params: {apptItemId: string, shelfStatus: number}) {
  return request('/hm/mall/appt/item/updateShelfStatus', {
    method: 'POST',
    params
  })
}

// /mall/appt/item/batch/remove 批量删除预约项目[管理后台]
export async function deleteBatchRemove(params: {ids: string}) {
  return request('/hm/mall/appt/item/batch/remove', {
    method: 'POST',
    params
  })
}

/** hm -- 健康商城-预约项目相关 -- 预约项目的分享二维码[管理后台]
 * @method GET
 * @url /hm/mall/appt/item/shareQrCode
 * @param {String} appId        *客户端id
 * @param {String} apptItemId   *商品id
 */
export async function getApptItemShareQrCode(params: ApptItemShareQrCodeParams) {
  return request('/hm/mall/appt/item/shareQrCode', { params })
}

